import DesktopLogo from '../assets/images/header/gqBlueLogo.png';

export const metaContent = {
    home: {
        title: `GrayQuest | India's Most Advanced Fee Payment Platform | ARC & RAPID Solutions`,
        description: `Transform your educational institution with GrayQuest's complete suite - ARC (Admissions & Fee Management) and RAPID (Payment Platform). Trusted by 6500+ institutes and 500k+ parents.`,
        keywords: [
            'education fee payment',
            'school fee management',
            'college fee payment',
            'admissions management software',
            'ARC GrayQuest',
            'RAPID payment platform',
            'educational institution payments',
            'fee collection platform',
            'student fee EMI',
            'zero cost EMI education',
            'fee payment solutions',
            'GrayQuest',
            'education fintech India',
            'admissions software',
            'fee management system',
        ],
    },
    about: {
        title: `About Us | GrayQuest - Empowering Education Through Easy Fee Payments`,
        description: `Learn about GrayQuest's mission to become the default method of paying education fees for 200M+ students. Discover our ARC and RAPID solutions transforming education.`,
        keywords: [
            'about GrayQuest',
            'education payment company',
            'fee management platform',
            'education fintech startup',
            'student fee solutions',
            'education technology',
            'fee payment innovation',
            'ARC admissions software',
            'RAPID payment platform',
        ],
    },
    parents: {
        title: `For Parents | Flexible Fee Payment Options | Zero Cost EMI | GrayQuest`,
        description: `Pay your child's fees with flexible options - Zero Cost EMI, auto-debit, multiple payment methods. Trusted by 500k+ parents across India.`,
        keywords: [
            'school fee payment for parents',
            'education fee EMI',
            'zero cost EMI school fees',
            'flexible fee payment',
            'parent fee payment options',
            'school fee financing',
            'education loan alternatives',
            'monthly fee payment',
            'fee payment app',
            'parent portal fee payment',
            'automated fee payment',
        ],
    },
    institute: {
        title: `For Educational Institutes | Complete Fee & Admissions Solution | ARC & RAPID | GrayQuest`,
        description: `Comprehensive education management with ARC (Admissions & Fee Management) and RAPID (Payment Platform). Streamline admissions, automate fee collection, and offer flexible payments.`,
        keywords: [
            'school fee collection software',
            'educational institute payments',
            'fee management system',
            'admissions management software',
            'ARC GrayQuest',
            'RAPID payment platform',
            'college fee collection',
            'institute payment solutions',
            'fee collection platform',
            'education payment gateway',
            'automated fee collection',
            'admissions software India',
            'school management system',
            'institute automation',
        ],
    },
    contact: {
        title: `Contact Us | Get in Touch with GrayQuest | Schedule Demo`,
        description: `Connect with GrayQuest for comprehensive education solutions. Schedule a demo of ARC and RAPID platforms, get support, or explore partnership opportunities.`,
        keywords: [
            'contact GrayQuest',
            'fee payment support',
            'education payment help',
            'GrayQuest customer service',
            'schedule demo',
            'partnership inquiries',
            'ARC demo',
            'RAPID demo',
            'education software demo',
        ],
    },
    careers: {
        title: `Careers | Join GrayQuest Team | Education Fintech Jobs`,
        description: `Join our mission to transform education through technology. Explore career opportunities at GrayQuest and be part of India's leading education fintech company.`,
        keywords: [
            'GrayQuest careers',
            'education fintech jobs',
            'payment platform jobs',
            'fintech careers India',
            'education technology jobs',
            'startup careers Mumbai',
            'software developer jobs',
            'product manager jobs',
            'sales jobs education',
        ],
    },
    blogs: {
        title: `Blog | Education Payment & Management Insights | GrayQuest`,
        description: `Read the latest insights on education payments, fee management, admissions automation, and financial planning for students and educational institutions.`,
        keywords: [
            'education payment blog',
            'fee management articles',
            'student finance tips',
            'education funding guides',
            'fee payment insights',
            'admissions management tips',
            'education technology trends',
            'fintech education blog',
        ],
    },
    // Adding missing pages
    lendingpartners: {
        title: `Our Lending Partners | Trusted Financial Institutions | GrayQuest`,
        description: `Discover GrayQuest's trusted lending partners providing Zero Cost EMI and flexible payment solutions for education fees across India.`,
        keywords: [
            'lending partners GrayQuest',
            'education loan providers',
            'financial partners',
            'EMI providers',
            'education finance partners',
            'student loan partners',
            'fee financing partners',
        ],
    },
    termsofservice: {
        title: `Terms of Service | GrayQuest`,
        description: `Read GrayQuest's terms of service for using our education fee payment platform and related services.`,
        keywords: [
            'terms of service',
            'service agreement',
            'GrayQuest terms',
            'user agreement',
            'platform terms',
        ],
    },
    instituteTermsofservice: {
        title: `Institute Terms of Service | GrayQuest`,
        description: `Terms of service specifically for educational institutions using GrayQuest's ARC and RAPID platforms.`,
        keywords: [
            'institute terms of service',
            'institutional agreement',
            'ARC terms',
            'RAPID terms',
            'education platform terms',
        ],
    },
    // Policy pages
    privacyPolicy: {
        title: `Privacy Policy | GrayQuest`,
        description: `Learn how GrayQuest protects your personal and financial information. Read our comprehensive privacy policy for students, parents, and institutions.`,
        keywords: [
            'privacy policy',
            'data protection',
            'information security',
            'GrayQuest privacy',
            'financial data security',
        ],
    },
    termsAndConditions: {
        title: `Terms and Conditions | GrayQuest`,
        description: `Read GrayQuest's terms and conditions for using our fee payment platform and services.`,
        keywords: [
            'terms and conditions',
            'service agreement',
            'GrayQuest terms',
            'payment terms',
            'platform usage terms',
        ],
    },
    grievanceOfficer: {
        title: `Grievance Officer | GrayQuest`,
        description: `Contact our grievance officer for any complaints or concerns regarding our fee payment services.`,
        keywords: [
            'grievance officer',
            'customer complaints',
            'GrayQuest support',
            'dispute resolution',
        ],
    },
    pageNotFound: {
        title: `Page Not Found | GrayQuest`,
        description: `The page you requested could not be found. Return to GrayQuest's homepage to explore our fee payment solutions.`,
        keywords: ['page not found', '404 error', 'GrayQuest'],
    },
};

// Enhanced structured data with complete service offerings
export const structuredDataContent = {
    home: {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'GrayQuest',
        alternateName: 'GrayQuest Education Finance',
        description: "India's most advanced fee payment platform for educational institutions, providing ARC (Admissions & Fee Management) and RAPID (Payment Platform) solutions. Trusted by 6500+ institutes and 500k+ parents.",
        url: 'https://grayquest.com',
        logo: {
            '@type': 'ImageObject',
            url: `https://grayquest.com${DesktopLogo}`,
            caption: 'GrayQuest Logo',
            width: '300',
            height: '100'
        },
        image: {
            '@type': 'ImageObject',
            url: `https://grayquest.com${DesktopLogo}`,
            width: '300',
            height: '100'
        },
        foundingDate: '2017',
        slogan: 'Empowering Education Through Easy Fee Payments',
        legalName: 'GrayQuest Education Finance Private Limited',
        numberOfEmployees: '300+',
        contactPoint: [
            {
                '@type': 'ContactPoint',
                telephone: '+919324507084',
                contactType: 'customer service',
                email: 'support@grayquest.com',
                areaServed: 'IN',
                availableLanguage: ['English', 'Hindi']
            },
            {
                '@type': 'ContactPoint',
                email: 'director@grayquest.com',
                contactType: 'business inquiries',
                areaServed: 'IN'
            }
        ],
        address: {
            '@type': 'PostalAddress',
            streetAddress: '17th floor, D wing, Trade World, Kamala Mills, Senapati Bapat Marg, Lower Parel',
            addressLocality: 'Mumbai',
            addressRegion: 'Maharashtra',
            postalCode: '400013',
            addressCountry: 'India'
        },
        sameAs: [
            'https://www.facebook.com/grayquest',
            'https://in.linkedin.com/company/grayquest',
            'https://twitter.com/gqfinance',
            'https://www.instagram.com/grayquest'
        ],
        founder: {
            '@type': 'Person',
            name: 'Rishab Mehta',
            jobTitle: 'CEO & Founder'
        },
        areaServed: {
            '@type': 'Country',
            name: 'India'
        },
        hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'Education Management Services',
            itemListElement: [
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'ARC Admissions Management',
                        description: 'Adaptive admissions software that streamlines application processing and student onboarding'
                    }
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'ARC Fee Management',
                        description: 'SAAS platform for automated fee collection and parent communication'
                    }
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'RAPID Payment Platform',
                        description: 'All-in-one payment solution with 8+ payment methods'
                    }
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'Zero Cost EMI',
                        description: 'Convert annual fees into monthly installments with 0% interest'
                    }
                }
            ]
        },
        knowsAbout: [
            'Education Fee Payment',
            'Student Finance',
            'Admissions Management',
            'Fee Collection Platform',
            'Zero Cost EMI',
            'Educational Institution Payment Solutions',
            'ARC Software',
            'RAPID Payment Platform'
        ]
    },
    about: {
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: 'About GrayQuest',
        description: "Learn about GrayQuest - India's largest education-focused payment platform serving 6500+ institutes with comprehensive ARC and RAPID solutions.",
        url: 'https://grayquest.com/about-us',
        mainEntity: {
            '@type': 'Organization',
            name: 'GrayQuest',
            founder: {
                '@type': 'Person',
                name: 'Rishab Mehta',
                jobTitle: 'CEO & Founder',
            },
            numberOfEmployees: '300+',
            foundingDate: '2017',
            award: [
                'Leading Education Fintech Company in India',
                'Trusted by 6500+ Educational Institutions'
            ]
        },
    },
    institute: {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Complete Education Management Solutions',
        description: 'Comprehensive suite including ARC (Admissions & Fee Management) and RAPID (Payment Platform) for educational institutions.',
        url: 'https://grayquest.com/institute',
        provider: {
            '@type': 'Organization',
            name: 'GrayQuest',
            url: 'https://grayquest.com',
        },
        serviceType: 'Education Management Platform',
        areaServed: 'India',
        hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'Institute Solutions',
            itemListElement: [
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'SoftwareApplication',
                        name: 'ARC Admissions Management',
                        description: 'Streamline your admission process with adaptive software that handles applications, document verification, and student onboarding',
                        applicationCategory: 'EducationApplication',
                        operatingSystem: 'Web-based',
                        featureList: [
                            'Application Management',
                            'Document Verification',
                            'Student Onboarding',
                            'Counselor Assignment',
                            'Applicant Profile Management'
                        ]
                    }
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'SoftwareApplication',
                        name: 'ARC Fee Management',
                        description: 'SAAS platform for automated fee collection, parent communication, and financial reporting',
                        applicationCategory: 'FinanceApplication',
                        operatingSystem: 'Web-based',
                        featureList: [
                            'Automated Fee Collection',
                            'Parent Communication Portal',
                            'Financial Reporting',
                            'Payment Tracking',
                            'Fee Structure Management'
                        ]
                    }
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'SoftwareApplication',
                        name: 'RAPID Payment Platform',
                        description: 'All-in-one payment solution supporting 8+ payment methods including cards, UPI, wallets, and net banking',
                        applicationCategory: 'PaymentApplication',
                        operatingSystem: 'Web-based',
                        featureList: [
                            'Credit/Debit Card Payments',
                            'UPI Payments',
                            'Digital Wallet Support',
                            'Net Banking',
                            'Auto-Debit Facility',
                            'Payment Analytics',
                            'Secure Transaction Processing',
                            'Multi-currency Support'
                        ]
                    }
                }
            ]
        }
    },
    parents: {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Fee Payment Solutions for Parents',
        description: 'Flexible fee payment options including zero cost EMI, auto-debit, and multiple payment methods for parents.',
        url: 'https://grayquest.com/parents',
        provider: {
            '@type': 'Organization',
            name: 'GrayQuest',
            url: 'https://grayquest.com',
        },
        serviceType: 'Education Fee Payment',
        areaServed: 'India',
        offers: [
            {
                '@type': 'Offer',
                name: 'Zero Cost EMI',
                description: 'Convert annual fees into monthly installments with 0% interest',
                price: '0',
                priceCurrency: 'INR'
            },
            {
                '@type': 'Offer',
                name: 'Auto-Debit Facility',
                description: 'Never miss a payment deadline with automated fee payments'
            },
            {
                '@type': 'Offer',
                name: 'Multiple Payment Options',
                description: '8+ payment methods including cards, UPI, wallets, and netbanking'
            },
        ],
    },
    contact: {
        '@context': 'https://schema.org',
        '@type': 'ContactPage',
        name: 'Contact GrayQuest',
        description: 'Get in touch with GrayQuest for comprehensive education solutions including ARC and RAPID platforms.',
        url: 'https://grayquest.com/contact',
        mainEntity: {
            '@type': 'Organization',
            name: 'GrayQuest',
            contactPoint: [
                {
                    '@type': 'ContactPoint',
                    telephone: '+919324507084',
                    contactType: 'customer service',
                    email: 'support@grayquest.com',
                    areaServed: 'IN',
                },
                {
                    '@type': 'ContactPoint',
                    email: 'director@grayquest.com',
                    contactType: 'business inquiries',
                    areaServed: 'IN',
                },
            ],
        },
    },
    careers: {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Careers at GrayQuest',
        description: 'Join GrayQuest team and help transform education through innovative payment and management solutions.',
        url: 'https://grayquest.com/careers',
        about: {
            '@type': 'Organization',
            name: 'GrayQuest',
            description: 'Leading education fintech company in India',
        },
        jobPosting: [
            {
                '@type': 'JobPosting',
                title: 'Manager - Key Accounts',
                department: 'Tech',
                employmentType: 'FULL_TIME',
                hiringOrganization: {
                    '@type': 'Organization',
                    name: 'GrayQuest',
                    sameAs: 'https://grayquest.com',
                },
            },
            {
                '@type': 'JobPosting',
                title: 'Associate - Operation',
                department: 'Operations',
                employmentType: 'FULL_TIME',
                hiringOrganization: {
                    '@type': 'Organization',
                    name: 'GrayQuest',
                    sameAs: 'https://grayquest.com',
                },
            },
        ],
    },
    // Additional pages structured data
    lendingpartners: {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Our Lending Partners',
        description: 'Trusted financial institutions partnering with GrayQuest to provide education financing solutions.',
        url: 'https://grayquest.com/lending-partners',
        about: {
            '@type': 'Organization',
            name: 'GrayQuest',
            description: 'Education finance platform with trusted lending partners'
        }
    },
    blogs: {
        '@context': 'https://schema.org',
        '@type': 'Blog',
        name: 'GrayQuest Blog',
        description: 'Latest insights on education payments, fee management, and financial planning.',
        url: 'https://grayquest.com/blogs',
        publisher: {
            '@type': 'Organization',
            name: 'GrayQuest',
            url: 'https://grayquest.com'
        }
    }
};

// FAQ Schema for better search visibility
export const FAQSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
        {
            '@type': 'Question',
            name: 'What is GrayQuest and what services do you offer?',
            acceptedAnswer: {
                '@type': 'Answer',
                text: 'GrayQuest is India\'s most advanced fee payment platform offering comprehensive education management solutions. We provide ARC (Admissions & Fee Management) and RAPID (Payment Platform) to 6500+ institutes and 500k+ parents across India.'
            }
        },
        {
            '@type': 'Question',
            name: 'What is ARC and how does it help educational institutions?',
            acceptedAnswer: {
                '@type': 'Answer',
                text: 'ARC is our comprehensive SAAS platform that includes Admissions Management (streamlining application processing and student onboarding) and Fee Management (automated fee collection and parent communication). It adapts to your institution\'s specific needs.'
            }
        },
        {
            '@type': 'Question',
            name: 'What is RAPID payment platform?',
            acceptedAnswer: {
                '@type': 'Answer',
                text: 'RAPID is our all-in-one payment platform that supports 8+ payment methods including credit cards, debit cards, UPI, digital wallets, net banking, and auto-debit facilities, making fee payments seamless for parents and institutions.'
            }
        },
        {
            '@type': 'Question',
            name: 'How does the Zero Cost EMI work for parents?',
            acceptedAnswer: {
                '@type': 'Answer',
                text: 'Our Zero Cost EMI allows parents to convert their annual education fees into monthly installments with 0% interest, helping them manage finances better without any additional cost burden.'
            }
        },
        {
            '@type': 'Question',
            name: 'Which educational institutions can use GrayQuest services?',
            acceptedAnswer: {
                '@type': 'Answer',
                text: 'GrayQuest serves all types of educational institutions including schools, colleges, universities, coaching centers, and EdTech platforms. We currently partner with over 6500+ institutions across India.'
            }
        },
        {
            '@type': 'Question',
            name: 'Is GrayQuest secure for financial transactions?',
            acceptedAnswer: {
                '@type': 'Answer',
                text: 'Yes, GrayQuest uses bank-grade security with SSL encryption, PCI DSS compliance, and follows RBI guidelines to ensure complete security of financial information and transactions.'
            }
        }
    ]
};

// Website Schema for search functionality
export const WebSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'GrayQuest',
    alternateName: 'GrayQuest Education Finance',
    url: 'https://grayquest.com',
    description: 'India\'s most advanced fee payment platform for educational institutions, providing ARC and RAPID solutions.',
    inLanguage: 'en-IN',
    copyrightYear: '2024',
    copyrightHolder: {
        '@type': 'Organization',
        name: 'GrayQuest'
    },
    potentialAction: {
        '@type': 'SearchAction',
        target: {
            '@type': 'EntryPoint',
            urlTemplate: 'https://grayquest.com/search?q={search_term_string}'
        },
        'query-input': 'required name=search_term_string'
    }
};

// LocalBusiness Schema for local SEO
export const LocalBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'FinancialService',
    name: 'GrayQuest',
    image: `https://grayquest.com${DesktopLogo}`,
    url: 'https://grayquest.com',
    telephone: '+919324507084',
    email: 'support@grayquest.com',
    address: {
        '@type': 'PostalAddress',
        streetAddress: '17th floor, D wing, Trade World, Kamala Mills, Senapati Bapat Marg, Lower Parel',
        addressLocality: 'Mumbai',
        addressRegion: 'Maharashtra',
        postalCode: '400013',
        addressCountry: 'India'
    },
    geo: {
        '@type': 'GeoCoordinates',
        latitude: '18.9956183',
        longitude: '72.8350966'
    },
    openingHours: 'Mo-Fr 09:00-18:00',
    description: 'Leading education finance company providing comprehensive solutions including ARC (Admissions & Fee Management) and RAPID (Payment Platform) for educational institutions across India.',
    priceRange: '$$',
    areaServed: {
        '@type': 'Country',
        name: 'India'
    },
    paymentAccepted: [
        'Credit Card',
        'Debit Card',
        'UPI',
        'Net Banking',
        'Digital Wallet'
    ],
    currenciesAccepted: 'INR'
};

// Article Schema generator for blog posts
export const createArticleSchema = (article) => {
    if (!article) return null;

    return {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: article.title,
        description: article.description || article.subtitle,
        image: article.banner ? `https://grayquest.com${article.banner}` : `https://grayquest.com/assets/images/blog-default.jpg`,
        author: {
            '@type': 'Organization',
            name: 'GrayQuest',
            url: 'https://grayquest.com'
        },
        publisher: {
            '@type': 'Organization',
            name: 'GrayQuest',
            url: 'https://grayquest.com',
            logo: {
                '@type': 'ImageObject',
                url: `https://grayquest.com${DesktopLogo}`,
                width: 300,
                height: 100
            }
        },
        datePublished: article.publishedAt,
        dateModified: article.updatedAt || article.publishedAt,
        url: `https://grayquest.com/blogs/${article.slug}`,
        mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': `https://grayquest.com/blogs/${article.slug}`
        },
        articleSection: 'Education Finance',
        keywords: article.keywords || ['education fee payment', 'student finance', 'GrayQuest', 'ARC', 'RAPID'],
        about: {
            '@type': 'Thing',
            name: 'Education Fee Payment'
        }
    };
};
